import { useEffect, useRef, useState } from "react";

/**
 * Steps 0..total-1 on a timer, looping, but only while the element is on screen.
 * With reduced motion it holds the last step, which each illustration treats as "everything shown".
 */
export function useLoopStep(total: number, interval: number) {
  const ref = useRef<HTMLDivElement>(null);
  const [step, setStep] = useState(0);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setStep(total - 1);
      return;
    }
    let timer = 0;
    const start = () => { if (!timer) timer = window.setInterval(() => setStep((s) => (s + 1) % total), interval); };
    const stop = () => { window.clearInterval(timer); timer = 0; };
    const observer = new IntersectionObserver(([entry]) => (entry.isIntersecting ? start() : stop()));
    observer.observe(node);
    return () => { observer.disconnect(); stop(); };
  }, [total, interval]);
  return [ref, step] as const;
}
